import { Component, Input, Output, EventEmitter } from '@angular/core';
import {NgStyle} from "@angular/common";
import {DbTextPipe} from "../../../../../../../shared/pipes/db-text.pipe";

@Component({
  selector: 'db-figma-image',
  imports: [
    NgStyle,
    DbTextPipe
  ],
  templateUrl: './figma-image.component.html',
  styleUrl: './figma-image.component.scss'
})
export class FigmaImageComponent {
  @Input() url: string | null = null;
  @Input() fileName: string | null = null;
  @Input() withBorder = false;
  @Input() isShown = true; // if you rely on show class
  /** Optional callback function (if parent passes a function) */
  @Input() previewImageFn?: () => void;

  /** Output for close action */
  @Output() closeFigma = new EventEmitter<void>();

  previewImage(): void {
    if (this.previewImageFn) {
      this.previewImageFn();
      return;
    }
    // otherwise emit event for parent to handle
    this.closeFigma.emit(); // use a dedicated event if you need separate events
  }

  onCloseClick(event?: MouseEvent): void {
    if (event) event.stopPropagation();
    this.closeFigma.emit();
  }
}
